import React from 'react'

interface MessageBannerProps {
  message?: string
  error?: string
}

const MessageBanner: React.FC<MessageBannerProps> = ({ message, error }) => {
  return (
    <>
      {message && (
        <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-green-800">{message}</p>
        </div>
      )}

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-800">{error}</p>
        </div>
      )}
    </>
  )
}

export default MessageBanner
